<div *ngIf="errorMsgs.length == 0">
	<div *ngIf="dataSource?.data?.length > 0" class="overflow-x">
		<app-data-table
			[PAGE_SIZE]="PREVIEW_TABLE_PAGE_SIZE"
			[dataSource]="dataSource"
			[dataType]="DATA_TYPE"
			[displayedColumns]="PREVIEW_TABLE_COLUMNS"
			[isStaticPagination]="true"
			[tableHeaders]="PREVIEW_TABLE_HEADERS"
			[tableIcons]="TABLE_ICONS"
			[totalNumberOfRecords]="environment.RFP_PREVIEW_TABLE_ROWS_LIMIT"
		>
		</app-data-table>
	</div>
</div>

<div *ngIf="errorMsgs.length > 0">
	<div>
		<ul class="font-size-13 danger-text">
			<li *ngFor="let error of errorMsgs">{{ error }}</li>
			<br />
		</ul>
	</div>
</div>

<div
	*ngIf="errorMsgs.length == 0"
	fxLayout="row"
	fxLayoutAlign="space-evenly center"
	style="margin-top: 1rem"
>
	<button mat-button mat-raised-button matStepperPrevious style="background-color: #f5f5f5">
		Back
	</button>
	<button (click)="uploadFile()" color="primary" mat-button mat-raised-button>Upload</button>
</div>

<div *ngIf="errorMsgs.length > 0" class="m-t-1" fxLayout="row" fxLayoutAlign="end center">
	<button
		(click)="resetFileData.emit()"
		color="primary"
		mat-button
		mat-raised-button
		matStepperPrevious
	>
		Reset
	</button>
</div>
